module.exports = __webpack_public_path__ + "static/how-we-do-illustration-95c7169c4ac4ff268042864874947ab3.svg";